let key = 0;
export const keyGen = () => {
  key++;
  return key;
};
